const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_BASE_URL_DEV
    : process.env.REACT_APP_API_BASE_URL;

export async function fetchCustomerAvailability(env = 'memo') {
  try {
    const response = await fetch(
      `${API_BASE_URL}/sync-map-items?env=${env}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch customer availability');
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Error in fetchCustomerAvailability:', err);
    throw err;
  }
}
